import '../index.css';
import Icon from '../components/Icon';
import ImageWrapper from '../components/ImageWrapper';
import culinary from '../img/culinary.png';
import bride from '../img/bride.png';
import cook from '../img/cook.jpg';
import Button from '../components/Button';
import ContactForm from '../components/ContactForm';
import Testimonials from '../components/Testimonials';

function Home() {
    return (
        <>
            <div className="bg-hero bg-left lg:bg-center bg-cover flex flex-col items-center justify-center text-center w-full h-screen">
                <div className="flex flex-col items-center justify-center text-center">
                    <h1 className="w-5/6 lg:w-3/4 text-5xl lg:text-7xl">Elevating Elegance, Crafting Perfection</h1>
                    <p className="text-2xl w-5/6 lg:w-1/2 my-4">Bespoke Events and Catering, Tailored to Fit Your Signature Style.</p>
                    <Button href="/contact">Get In Touch</Button>
                </div>
            </div>
            <div className="page__width mt-20 flex flex-col items-center">
                <h5 className="uppercase text-brand text-sm">Our Services</h5>
                <h2 className="text-3xl lg:text-5xl text-white text-center lg:text-start">
                    Creating Moments That Matter
                </h2>
                <div className="w-full flex flex-col gap-8 lg:flex-row items-center mt-8 justify-between">
                    <div className="flex flex-col gap-2 w-full lg:w-1/3 items-center">
                        <Icon
                            name="corporate-events"
                            className="w-24 h-24"
                        />
                        <h3 className="text-xl lg:text-3xl text-white text-center">
                            Corporate Events
                        </h3>
                        <p className="w-5/6 text-text text-base lg:text-lg text-center">
                            Getting Married? Say 'I Do' to Stress-Free Planning
                            for your dream wedding
                        </p>
                    </div>
                    <div className="flex flex-col gap-2 w-full lg:w-1/3 items-center">
                        <Icon
                            name="social-gatherings"
                            className="w-24 h-24"
                        />
                        <h3 className="text-xl lg:text-3xl text-white text-center">
                            Social Gatherings
                        </h3>
                        <p className="w-5/6 text-text text-base lg:text-lg text-center">
                            Getting Married? Say 'I Do' to Stress-Free Planning
                            for your dream wedding
                        </p>
                    </div>
                    <div className="flex flex-col gap-2 w-full lg:w-1/3 items-center">
                        <Icon
                            name="wedding"
                            className="w-24 h-24"
                        />
                        <h3 className="text-xl lg:text-3xl text-white text-center">
                            Wedding Ceremonies
                        </h3>
                        <p className="w-5/6 text-text text-base lg:text-lg text-center">
                            Getting Married? Say 'I Do' to Stress-Free Planning
                            for your dream wedding
                        </p>
                    </div>
                </div>
                    <Button href="/services" additionalStyles="mt-8">View All Services</Button>
            </div>
            <div className="relative page__width mt-40 flex flex-col lg:flex-row items-start justify-between">
            <ImageWrapper src={bride} className="absolute hidden lg:block w-1/5 left-full -bottom-12" alt="Bride" />
            <ImageWrapper
                    className="lg:sticky lg:top-24 w-full lg:w-1/2"
                    alt="Crafting Culinary Memories"
                    src={culinary}
                />
                <div className="hidden lg:block bg-secondary w-1/2 h-1/2 absolute -z-50 bottom-40 -left-40"></div>
                <div className="flex flex-col lg:pl-8 w-full lg:w-1/2 gap-1 mt-4 items-center lg:items-start">
                    <h5 className="uppercase text-brand text-center lg:text-start text-sm">
                        Our Services
                    </h5>
                    <h2 className="text-3xl lg:text-5xl text-center lg:text-start text-white">
                        Creating Moments That Matter
                    </h2>
                    <p className="w-5/6 text-text text-base lg:text-lg text-center lg:text-start">
                        Sed ut perspiciatis unde omnis iste natus error sit
                        voluptatem accusantium doloremque laudantium, totam rem
                        aperiam. Sed ut perspiciatis unde omnis.
                    </p>

                    <div className="flex flex-col w-full gap-1 mt-4 items-center lg:items-start">
                        <Icon
                            name="gourmet"
                            className="w-8 h-8"
                        />
                        <h3 className="text-xl lg:text-2xl text-white">
                            Gourmet cuisine
                        </h3>
                        <p className="w-5/6 text-text text-base lg:text-lg text-center lg:text-start">
                            Sed ut perspiciatis unde omnis iste natus error sit
                            voluptatem accusantium doloremque laudantium, totam
                            rem aperiam. Sed ut perspiciatis unde omnis.
                        </p>
                    </div>
                    <div className="flex flex-col w-full gap-1 mt-4 items-center lg:items-start">
                        <Icon
                            name="cheers"
                            className="w-8 h-8"
                        />
                        <h3 className="text-xl lg:text-2xl text-white">
                            Modern catering
                        </h3>
                        <p className="w-5/6 text-text text-base lg:text-lg text-center lg:text-start">
                            Sed ut perspiciatis unde omnis iste natus error sit
                            voluptatem accusantium doloremque laudantium, totam
                            rem aperiam. Sed ut perspiciatis unde omnis.
                        </p>
                    </div>
                    <div className="flex flex-col w-full gap-1 mt-4 items-center lg:items-start">
                        <Icon
                            name="bowl"
                            className="w-8 h-8"
                        />
                        <h3 className="text-xl lg:text-2xl text-white">
                            The art of serving
                        </h3>
                        <p className="w-5/6 text-text text-base lg:text-lg text-center lg:text-start">
                            Sed ut perspiciatis unde omnis iste natus error sit
                            voluptatem accusantium doloremque laudantium, totam
                            rem aperiam. Sed ut perspiciatis unde omnis.
                        </p>
                    </div>
                </div>
            </div>
            <div className="page__width relative mt-40 flex flex-col lg:flex-row items-start justify-between">
                <div className="w-full lg:w-1/2 flex flex-col">
                    <h5 className="uppercase text-brand text-center lg:text-start text-sm">
                        Catering
                    </h5>
                    <h2 className="text-3xl lg:text-5xl text-center lg:text-start text-white">
                        We are here to create an event that leaves you speechless and turns you into a storyteller.
                    </h2>
                    <ImageWrapper
                        src={cook}
                        className="w-4/5 my-8 lg:mt-8"
                    />
                </div>
                <div className="w-full lg:w-1/2 flex flex-col gap-4">
                <p className="w-full text-text text-base lg:text-lg text-center lg:text-start">
                        Throughout my journey, I’ve had the privilege of meeting
                        and collaborating with some of the industry's finest
                        professionals, forging connections that span continents
                        and cultures.
                    </p>
                    <p className="w-full text-text text-base lg:text-lg text-center lg:text-start">
                        The trust and shared vision of the incredible clients
                        I’ve had the honour to work with have turned my job into
                        a true passion, making every moment truly worthwhile. My
                        team and I are dedicated to curating exceptional events
                        that leave lasting impressions, ensuring that every
                        detail reflects the highest standards of luxury and
                        elegance.
                    </p>
                    <div className="flex items-start justify-center lg:justify-start gap-16">
                        <div className="flex flex-col items-center">
                            <h3 className="text-4xl lg:text-7xl text-brand">
                                140
                            </h3>
                            <p className="text-text text-base lg:text-lg text-center">
                                Satisfied Clients
                            </p>
                        </div>
                        <div className="flex flex-col items-center">
                            <h3 className="text-4xl lg:text-7xl text-brand">
                                38
                            </h3>
                            <p className="text-text text-base lg:text-lg text-center">
                                Events Hosted
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="relative bg-secondary py-16 mt-40 flex flex-col items-center justify-between">
                <Testimonials />
            </div>

            <div className="page__width flex flex-col lg:flex-row gap-8 lg:gap-0 items-start justify-between my-40">
                <div className="w-full lg:w-2/5 flex flex-col items-start gap-2 lg:gap-4">
                    <h3 className="text-xl lg:text-2xl text-white">
                        Contact details
                    </h3>
                    <p className="w-full text-text text-base lg:text-lg ">
                        25 Thurso House, Randolph Gardens, NW65EL <br />
                        London, United Kingdom
                    </p>
                    <a
                        href="mailto:mariyan.alekov@smoothaffairs.co.uk"
                        target="_blank"
                        rel="noreferrer"
                        className="w-full text-brand underline text-base lg:text-lg ">
                        mariyan.alekov@smoothaffairs.co.uk
                    </a>
                    <p className="w-full text-text text-base lg:text-lg ">
                        +44 748 022 99 43
                    </p>
                </div>
                <div className="w-full lg:w-3/5 flex flex-col items-start">
                    <h2 className="text-3xl lg:text-5xl text-center lg:text-start text-white">
                        Contact Us
                    </h2>
                    <ContactForm />
                </div>
            </div>
        </>
    );
}

export default Home;
